import Cookies from 'js-cookie';

const oidcCookieName = 'atv2';

export const getOidcAccessToken = (): string => {
  return Cookies.get(oidcCookieName) || '';
};

export const deleteOidcAccessToken = () => {
  Cookies.remove(oidcCookieName);
};
